/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Experiences_P2Inputs */

const es_marketplace_seo_spain_guide_experiences_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son actividades con patrón incluido, pensadas para grupos que buscan una jornada completa sin preocuparse por la logística.`)
};

const gl_marketplace_seo_spain_guide_experiences_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son actividades con patrón incluído, pensadas para grupos que buscan unha xornada completa sen preocuparse pola loxística.`)
};

const en_marketplace_seo_spain_guide_experiences_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are skipper-led activities designed for groups who want a full day without worrying about logistics.`)
};

/**
* | output |
* | --- |
* | "These are skipper-led activities designed for groups who want a full day without worrying about logistics." |
*
* @param {Marketplace_Seo_Spain_Guide_Experiences_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_experiences_p2 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Experiences_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Experiences_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_experiences_p2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_experiences_p2(inputs)
	return es_marketplace_seo_spain_guide_experiences_p2(inputs)
});